import React from 'react';
import { formatCurrency, parseCurrency } from './formatUtils';

const FieldRow = ({
  label,
  code,
  value,
  onChange,
  computed = false,
  disabled = false,
  sign = '',
  type = 'currency',
  placeholder = '',
  suffix = '',
  decimals = 0,
  className = '',
}) => {
  const handleChange = (e) => {
    if (!onChange) return;
    const raw = e.target.value;
    if (type === 'currency') {
      onChange(parseCurrency(raw));
    } else if (type === 'percent') {
      onChange(parseFloat(raw) || 0);
    } else if (type === 'number') {
      onChange(parseFloat(raw) || 0);
    } else {
      onChange(raw);
    }
  };

  const displayValue = () => {
    if (value === undefined || value === null || value === '') return '';
    if (type === 'currency') return formatCurrency(value);
    if (type === 'percent') return value;
    if (type === 'number') {
      return decimals > 0 ? Number(value).toFixed(decimals) : value;
    }
    return value;
  };

  return (
    <div className={`f22-field-row ${computed ? 'computed' : ''} ${disabled ? 'f22-field-disabled' : ''} ${className}`}>
      <div className="f22-field-sign">{sign}</div>
      {code && <div className="f22-field-code">{code}</div>}
      <div className="f22-field-label">{label}</div>
      <div className="f22-field-value">
        {computed || disabled ? (
          <span className={computed ? 'f22-computed-value' : 'f22-system-value'}>
            {displayValue()}{suffix}
          </span>
        ) : (
          <input
            type="text"
            className="f22-input"
            value={displayValue()}
            onChange={handleChange}
            placeholder={placeholder}
          />
        )}
      </div>
    </div>
  );
};

export default FieldRow;
